<div class="modal-header">
  <h5 class="modal-title">{{ 'AI_PARSER_CONFIG_SAVE' | translate }}</h5>
  <button type="button" class="btn-close" (click)="close()" [attr.aria-label]="'CANCEL' | translate"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label for="configName" class="form-label">{{ 'AI_PARSER_CONFIG_NAME' | translate }}</label>
    <input
      id="configName"
      type="text"
      class="form-control"
      [class.is-invalid]="!!error || nameConflict"
      [(ngModel)]="name"
      (ngModelChange)="error = ''"
      ngbAutofocus
    />
    <div *ngIf="error" class="invalid-feedback d-block">{{ error }}</div>
    <div *ngIf="nameConflict" class="invalid-feedback d-block">
      {{ 'AI_PARSER_CONFIG_NAME_TAKEN' | translate }}
    </div>
  </div>

  <div class="summary">
    <div *ngIf="draft.aiInstructions">
      <span class="summary-label">{{ 'AI_PARSER_AI_INSTRUCTIONS' | translate }}</span>
      {{ draft.aiInstructions }}
    </div>
    <div *ngIf="draft.suggestedDeliveryCustomerId">
      <span class="summary-label">{{ 'AI_PARSER_DELIVERY_CUSTOMER' | translate }}</span>
      {{ draft.suggestedDeliveryCustomerId }}
    </div>
    <div *ngIf="draft.suggestedBillingCustomerId">
      <span class="summary-label">{{ 'AI_PARSER_BILLING_CUSTOMER' | translate }}</span>
      {{ draft.suggestedBillingCustomerId }}
    </div>
    <div *ngIf="!draft.aiInstructions && !draft.suggestedDeliveryCustomerId && !draft.suggestedBillingCustomerId" class="summary-empty">
      {{ 'AI_PARSER_CONFIG_EMPTY_NOTE' | translate }}
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-link text-secondary" (click)="close()">{{ 'CANCEL' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!name.trim() || nameConflict">
    {{ 'SAVE' | translate }}
  </button>
</div>
